import _asyncToGenerator from "/home/bigstep/Public/googlemediapipe/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */
/**
 * Interfaces and methods for training models using TensorFlow.js datasets.
 */
import * as tfc from '@tensorflow/tfjs-core';
import { scalar } from '@tensorflow/tfjs-core';
import { configureCallbacks, standardizeCallbacks } from '../base_callbacks';
import { NotImplementedError, ValueError } from '../errors';
import { disposeTensorsInLogs } from '../logs';
import { singletonOrArray, toList } from '../utils/generic_utils';
import { standardizeClassWeights, standardizeWeights } from './training_utils';
// Default batch size used during tensor-based validation.
var DEFAULT_VALIDATION_BATCH_SIZE = 32;
/**
 * Standardize the output of a dataset iterator for use by
 * LayersModel.fitDataset().
 *
 * @param model: A `tf.LayersModel` object.
 * @param iteratorOut The output of a dataset iterator. It is required to be
 *   an object of the form `{xs: TensorOrArrayOrMap, ys:
 * TensorOrArrayOrMap}`, where `TensorOrArrayOrMap` is a single `tf.Tensor`,
 * a `tf.Tensor[]`, or a flat map from string names to `tf.Tensor`s.
 * @returns A flat array of `tf.Tensor` objects: the input `tf.Tensor`s
 *   followed by the target `tf.Tensor`s.  When `tf.Tensor`s are provided
 *   as a map, the order in the resulting array is taken from the `inputNames`
 *   and `outputNames` of the model.
 */
function standardizeDataIteratorOutput(
// Type `model` as `any` here to avoid circular dependency w/
// training.ts.
// tslint:disable-next-line:no-any
model, iteratorOut) {
  var xs;
  var ys;
  var iteratorOutObj = iteratorOut;
  xs = iteratorOutObj['xs'];
  ys = iteratorOutObj['ys'];
  tfc.util.assert(xs != null && ys != null, function () {
    return 'A Dataset iterator for fitDataset() is expected to generate ' + 'objects of the form `{xs: xVal, ys: yVal}`, where the two ' + 'values may be `tf.Tensor`, an array of Tensors, or a map of ' + 'string to Tensor.  The provided Dataset instead generates ' + "".concat(iteratorOut);
  });
  var flattenedXs = flattenTensorOrArrayOrMap('input', model.inputNames, xs);
  var flattenedYs = flattenTensorOrArrayOrMap('output', model.outputNames, ys);
  var batchSize = flattenedXs[0].shape[0];
  tfc.util.assert(flattenedXs.length === model.inputs.length, function () {
    return "LayersModel has ".concat(model.inputs.length, " inputs, but the dataset ") + "provides ".concat(flattenedXs.length, " inputs.  (Expected input keys: ") + "".concat(JSON.stringify(model.inputNames), ")");
  });
  tfc.util.assert(flattenedYs.length === model.outputs.length, function () {
    return "LayersModel has ".concat(model.outputs.length, " outputs, but the dataset ") + "provides ".concat(flattenedYs.length, " outputs.  (Expected output keys: ") + "".concat(JSON.stringify(model.outputNames), ")");
  });
  var _loop = function _loop(xIndex) {
    tfc.util.assert(flattenedXs[xIndex].shape[0] === batchSize, function () {
      return "Batch size mismatch: input " + "".concat(model.inputNames[xIndex], " has ").concat(flattenedXs[xIndex].shape[0], "; ") + "expected  ".concat(batchSize, " based on input ").concat(model.inputNames[0], ".");
    });
  };
  for (var xIndex = 0; xIndex < flattenedXs.length; xIndex++) {
    _loop(xIndex);
  }
  var _loop2 = function _loop2(yIndex) {
    tfc.util.assert(flattenedYs[yIndex].shape[0] === batchSize, function () {
      return "Batch size mismatch: output " + "".concat(model.outputNames[yIndex], " has ").concat(flattenedYs[yIndex].shape[0], "; ") + "expected  ".concat(batchSize, " based on input ").concat(model.inputNames[0], ".");
    });
  };
  for (var yIndex = 0; yIndex < flattenedYs.length; yIndex++) {
    _loop2(yIndex);
  }
  return {
    xs: flattenedXs,
    ys: flattenedYs
  };
}
function flattenTensorOrArrayOrMap(inputOrOutput, names, values) {
  if (values instanceof tfc.Tensor) {
    return [values];
  } else if (Array.isArray(values)) {
    tfc.util.assert(values.length === names.length, function () {
      return "Received an array of ".concat(values.length, " Tensors, but expected ").concat(names.length, " to match the ").concat(inputOrOutput, " keys ").concat(names, ".");
    });
    return values;
  } else {
    var result = [];
    // Check that all the required keys are available.
    var _iterator = _createForOfIteratorHelper(names),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var name = _step.value;
        if (values[name] == null) {
          throw new ValueError("The feature data generated by the dataset lacks the required " + "".concat(inputOrOutput, " key '").concat(name, "'."));
        }
        result.push(values[name]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    return result;
  }
}
function standardizeTensorValidationData(data) {
  if (data.length === 3) {
    throw new NotImplementedError('Validation with sample weights is not implemented yet.');
  }
  return {
    xs: data[0],
    ys: data[1]
  };
}
export function fitDataset(_x, _x2, _x3) {
  return _fitDataset.apply(this, arguments);
}
/** Helper function that determines number of steps (batches) per epoch. */
function _fitDataset() {
  _fitDataset = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(
  // Type `model` as `any` here to avoid circular dependency w/
  // training.ts.
  // tslint:disable-next-line:no-any
  model, dataset, args) {
    var hasBatchesPerEpoch, doValidation, valXs, valYs, validationData, trainFunction, outLabels, callbackMetrics, callbacks, verbose, _configureCallbacks, callbackList, history, epoch, dataIterator, epochLogs, stepsDone, batchIndex, iteratorOut, _standardizeDataItera, xs, ys, batchLogs, sampleWeights, standardClassWeights, i, ins, outs, _i, label, out, valOuts, _i2;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          hasBatchesPerEpoch = args.batchesPerEpoch != null;
          tfc.util.assert(model.optimizer != null, function () {
            return 'You must compile a model before training/testing. Use ' + 'LayersModel.compile(modelCompileConfig).';
          });
          tfc.util.assert(args != null, function () {
            return "For fitDataset(), the 2nd argument (config) is required, " + "but it is not provided in this call.";
          });
          tfc.util.assert(args.epochs != null && args.epochs > 0 && Number.isInteger(args.epochs), function () {
            return "For fitDataset(), config.epochs is expected to be a positive " + "integer, but got ".concat(args.epochs);
          });
          tfc.util.assert(!hasBatchesPerEpoch || args.batchesPerEpoch > 0 && Number.isInteger(args.batchesPerEpoch), function () {
            return "For fitDataset(), config.batchesPerEpoch is expected to be a " + "positive integer if specified, but got ".concat(args.batchesPerEpoch);
          });
          tfc.util.assert(
          // tslint:disable-next-line:no-any
          args['validationSplit'] == null, function () {
            return '`validationSplit` is not supported by `fitDataset()`. ' + 'Use validationData instead.';
          });
          if (!model.isTraining) {
            _context.next = 8;
            break;
          }
          throw new Error('Cannot start training because another fit() call is ongoing.');
        case 8:
          model.isTraining = true;
          _context.prev = 9;
          doValidation = args.validationData != null;
          if (doValidation) {
            if (isDatasetObject(args.validationData)) {
              tfc.util.assert(args.validationBatches == null || args.validationBatches > 0 && Number.isInteger(args.validationBatches), function () {
                return "For fitDataset() with dataset-based validation, " + "config.validationBatches is expected not to be provided, " + "or to be a positive integer, " + "but got ".concat(args.validationBatches);
              });
            } else {
              validationData = standardizeTensorValidationData(args.validationData);
              valXs = validationData.xs;
              valYs = validationData.ys;
            }
          }
          trainFunction = model.makeTrainFunction();
          outLabels = model.getDedupedMetricsNames();
          if (doValidation) {
            callbackMetrics = outLabels.slice().concat(outLabels.map(function (n) {
              return 'val_' + n;
            }));
          } else {
            callbackMetrics = outLabels.slice();
          }
          callbacks = standardizeCallbacks(args.callbacks, args.yieldEvery);
          verbose = args.verbose == null ? 1 : args.verbose;
          _configureCallbacks = configureCallbacks(callbacks, verbose, args.epochs, null, null, getStepsPerEpoch(dataset, args), null,
          // Batch size determined by the dataset itself.
          doValidation, callbackMetrics), callbackList = _configureCallbacks.callbackList, history = _configureCallbacks.history;
          callbackList.setModel(model);
          model.history = history;
          _context.next = 22;
          return callbackList.onTrainBegin();
        case 22:
          model.stopTraining_ = false;
          epoch = args.initialEpoch == null ? 0 : args.initialEpoch;
          _context.next = 26;
          return dataset.iterator();
        case 26:
          dataIterator = _context.sent;
        case 27:
          if (!(epoch < args.epochs)) {
            _context.next = 98;
            break;
          }
          epochLogs = {};
          _context.next = 31;
          return callbackList.onEpochBegin(epoch);
        case 31:
          stepsDone = 0;
          batchIndex = 0;
          if (hasBatchesPerEpoch) {
            _context.next = 37;
            break;
          }
          _context.next = 36;
          return dataset.iterator();
        case 36:
          dataIterator = _context.sent;
        case 37:
          if (!(hasBatchesPerEpoch ? stepsDone < args.batchesPerEpoch : true)) {
            _context.next = 91;
            break;
          }
          _context.next = 40;
          return dataIterator.next();
        case 40:
          iteratorOut = _context.sent;
          if (!(hasBatchesPerEpoch && iteratorOut.done)) {
            _context.next = 44;
            break;
          }
          console.warn('You provided `batchesPerEpoch` as ' + "".concat(args.batchesPerEpoch, ", ") + 'but your dataset iterator ran out of data after ' + "".concat(stepsDone, " batches; ") + 'interrupting training. Make sure that your ' + 'dataset can generate at least `batchesPerEpoch * epochs` ' + 'batches (in this case, ' + "".concat(args.batchesPerEpoch * args.epochs, " batches). ") + 'You may need to use the repeat() function when building ' + 'your dataset.');
          return _context.abrupt("break", 91);
        case 44:
          if (!(iteratorOut.value != null)) {
            _context.next = 73;
            break;
          }
          _standardizeDataItera = standardizeDataIteratorOutput(model, iteratorOut.value), xs = _standardizeDataItera.xs, ys = _standardizeDataItera.ys;
          batchLogs = {};
          batchLogs['batch'] = batchIndex;
          batchLogs['size'] = xs[0].shape[0];
          _context.next = 51;
          return callbackList.onBatchBegin(batchIndex, batchLogs);
        case 51:
          sampleWeights = [];
          if (!(args.classWeight != null)) {
            _context.next = 64;
            break;
          }
          standardClassWeights = standardizeClassWeights(args.classWeight, model.outputNames);
          i = 0;
        case 55:
          if (!(i < standardClassWeights.length)) {
            _context.next = 64;
            break;
          }
          _context.t0 = sampleWeights;
          _context.next = 59;
          return standardizeWeights(ys[i], null, standardClassWeights[i]);
        case 59:
          _context.t1 = _context.sent;
          _context.t0.push.call(_context.t0, _context.t1);
        case 61:
          ++i;
          _context.next = 55;
          break;
        case 64:
          // Train on batch.
          ins = xs.concat(ys).concat(sampleWeights);
          outs = trainFunction(ins);
          tfc.dispose(ins);
          for (_i = 0; _i < outLabels.length; ++_i) {
            label = outLabels[_i];
            out = outs[_i];
            batchLogs[label] = out;
            tfc.keep(out);
          }
          _context.next = 70;
          return callbackList.onBatchEnd(batchIndex, batchLogs);
        case 70:
          disposeTensorsInLogs(batchLogs);
          batchIndex++;
          stepsDone++;
        case 73:
          if (!(hasBatchesPerEpoch ? stepsDone >= args.batchesPerEpoch : iteratorOut.done)) {
            _context.next = 87;
            break;
          }
          if (!doValidation) {
            _context.next = 86;
            break;
          }
          valOuts = void 0;
          if (!isDatasetObject(args.validationData)) {
            _context.next = 84;
            break;
          }
          _context.t2 = toList;
          _context.next = 80;
          return model.evaluateDataset(args.validationData, {
            batches: args.validationBatches
          });
        case 80:
          _context.t3 = _context.sent;
          valOuts = (0, _context.t2)(_context.t3);
          _context.next = 85;
          break;
        case 84:
          valOuts = toList(model.evaluate(valXs, valYs, {
            batchSize: args.validationBatchSize == null ? DEFAULT_VALIDATION_BATCH_SIZE : args.validationBatchSize,
            verbose: 0
          }));
        case 85:
          for (_i2 = 0; _i2 < model.metricsNames.length; ++_i2) {
            epochLogs["val_".concat(model.metricsNames[_i2])] = valOuts[_i2];
          }
        case 86:
          return _context.abrupt("break", 91);
        case 87:
          if (!model.stopTraining_) {
            _context.next = 89;
            break;
          }
          return _context.abrupt("break", 91);
        case 89:
          _context.next = 37;
          break;
        case 91:
          _context.next = 93;
          return callbackList.onEpochEnd(epoch, epochLogs);
        case 93:
          epoch++;
          if (!model.stopTraining_) {
            _context.next = 96;
            break;
          }
          return _context.abrupt("break", 98);
        case 96:
          _context.next = 27;
          break;
        case 98:
          _context.next = 100;
          return callbackList.onTrainEnd();
        case 100:
          _context.next = 102;
          return model.history.syncData();
        case 102:
          return _context.abrupt("return", model.history);
        case 103:
          _context.prev = 103;
          model.isTraining = false;
          return _context.finish(103);
        case 106:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[9,, 103, 106]]);
  }));
  return _fitDataset.apply(this, arguments);
}
function getStepsPerEpoch(dataset, args) {
  // Attempt to determine # of batches in an epoch.
  var stepsPerEpoch = null;
  if (args.batchesPerEpoch != null) {
    stepsPerEpoch = args.batchesPerEpoch;
  } else if (Number.isFinite(dataset.size)) {
    stepsPerEpoch = dataset.size;
  }
  return stepsPerEpoch;
}
// Check if provided object is a Dataset object by checking its .iterator
// element.
function isDatasetObject(dataset) {
  return typeof dataset.iterator === 'function';
}
// Check if provided object is a LazyIterator object by checking it's .next
// element.
function isLazyIteratorObject(iterator) {
  return typeof iterator.next === 'function';
}
export function evaluateDataset(_x4, _x5, _x6) {
  return _evaluateDataset.apply(this, arguments);
}
function _evaluateDataset() {
  _evaluateDataset = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(
  // Type `model` as `any` here to avoid circular dependency w/
  // training.ts.
  // tslint:disable-next-line:no-any
  model, dataset, args) {
    var hasBatches, f, outs, dataIterator, numExamples, batch, _loop3, _ret, i, oldScalar;
    return _regeneratorRuntime().wrap(function _callee2$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          args = args || {};
          hasBatches = args.batches != null;
          f = model.testFunction;
          outs = [];
          if (!(args.verbose > 0)) {
            _context3.next = 6;
            break;
          }
          throw new NotImplementedError('Verbose mode is not implemented yet.');
        case 6:
          tfc.util.assert(!hasBatches || args.batches > 0 && Number.isInteger(args.batches), function () {
            return 'Test loop expects `batches` to be a positive integer, but ' + "received ".concat(JSON.stringify(args.batches));
          });
          if (!isLazyIteratorObject(dataset)) {
            _context3.next = 11;
            break;
          }
          _context3.t0 = dataset;
          _context3.next = 14;
          break;
        case 11:
          _context3.next = 13;
          return dataset.iterator();
        case 13:
          _context3.t0 = _context3.sent;
        case 14:
          dataIterator = _context3.t0;
          // Keeps track of number of examples used in this evaluation.
          numExamples = 0;
          batch = 0;
          _loop3 = /*#__PURE__*/_regeneratorRuntime().mark(function _loop3() {
            var iteratorOut;
            return _regeneratorRuntime().wrap(function _loop3$(_context2) {
              while (1) switch (_context2.prev = _context2.next) {
                case 0:
                  _context2.next = 2;
                  return dataIterator.next();
                case 2:
                  iteratorOut = _context2.sent;
                  outs = tfc.tidy(function () {
                    if (iteratorOut.value) {
                      // TODO(cais): Once real dataset is available, use
                      //   `map(x => standardizeDataIteratorOutput(model, x).map(f)`.
                      var _standardizeDataItera2 = standardizeDataIteratorOutput(model, iteratorOut.value),
                        xs = _standardizeDataItera2.xs,
                        ys = _standardizeDataItera2.ys;
                      var xsAndYs = xs.concat(ys);
                      var batchOuts = tfc.tidy(function () {
                        return f(xsAndYs);
                      });
                      tfc.dispose(xsAndYs);
                      if (batch === 0) {
                        for (var _i3 = 0; _i3 < batchOuts.length; ++_i3) {
                          outs.push(scalar(0));
                        }
                      }
                      var batchSize = xsAndYs[0].shape[0];
                      var _loop4 = function _loop4(i) {
                        var batchOut = batchOuts[i];
                        var oldScalar = outs[i];
                        outs[i] = tfc.tidy(function () {
                          return tfc.add(outs[i], tfc.mul(batchSize, batchOut));
                        });
                        if (batch > 0) {
                          tfc.dispose(oldScalar);
                        }
                      };
                      for (var _i4 = 0; _i4 < batchOuts.length; ++_i4) {
                        _loop4(_i4);
                      }
                      tfc.dispose(batchOuts);
                      numExamples += batchSize;
                      ++batch;
                    }
                    return outs;
                  });
                  if (!iteratorOut.done) {
                    _context2.next = 7;
                    break;
                  }
                  if (hasBatches) {
                    console.warn('Your dataset iterator ran out of data during evaluateDataset(). ' + 'Interrupting evalution. Make sure that your ' + 'dataset can generate at least `batches` ' + "batches (in this case, ".concat(args.batches, " batches). ") + 'You may need to use the repeat() function when building ' + 'your dataset.');
                  }
                  return _context2.abrupt("return", "break");
                case 7:
                case "end":
                  return _context2.stop();
              }
            }, _loop3);
          });
        case 18:
          if (!(hasBatches ? batch < args.batches : true)) {
            _context3.next = 25;
            break;
          }
          return _context3.delegateYield(_loop3(), "t1", 20);
        case 20:
          _ret = _context3.t1;
          if (!(_ret === "break")) {
            _context3.next = 23;
            break;
          }
          return _context3.abrupt("break", 25);
        case 23:
          _context3.next = 18;
          break;
        case 25:
          for (i = 0; i < outs.length; ++i) {
            oldScalar = outs[i];
            outs[i] = tfc.div(outs[i], numExamples);
            tfc.dispose(oldScalar);
          }
          return _context3.abrupt("return", singletonOrArray(outs));
        case 27:
        case "end":
          return _context3.stop();
      }
    }, _callee2);
  }));
  return _evaluateDataset.apply(this, arguments);
}